module.exports = __webpack_public_path__ + "img/r1.57dc6e6d.jpg";